import { Directive, Input, Output, Component, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import 'rxjs/add/operator/do';

// import { Observable } from 'rxjs';
// import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

declare function require(arg:string): any;

// Signo JQuery $ para modal
declare let $: any;

@Component({
  selector: 'mbx-group',
  templateUrl: './group.template.html',
  styleUrls   : ['./group.css', '../styles/mbx-custom.css', '../styles/esscalo.css'],
  providers: []
})
export class GroupComponent implements OnInit {

  private clients_            : any;
  private new_client_         : any;
  private new_beneficiary_    : any;
  private services_data_      : any;
  private users_datasource_   : any;
  private insurances_client_  : any;

  loader      = require('../../assets/images/loader/loading-yellow.gif');
  fileCarList;
  user_info;
  file_selected;
  is_full_admin;
  admin;
  data = {
    name: '',
    email: '',
    telefono: '', 
    direccion: '',
    rfc: '',
    pais: '',
    ciudad: '',
    file: null,
    file_: {}
  };

  data_complemento_group = [{
    url : null,
    grupo : '',
    cliente: '',
    modalidad: '',
    asesor_venta: '',
    agencia: [{
    nombre:'',
    url:''
    }]
  }];

  datasource = {
    first_name: '',
    last_name: '',
    email: '',
    password: '', 
    grupo: '',
    username: '',
    admin2: false
  }
  datasource_agencias = {
    nombre: '',
    es_activo: true,
  }
  datasource_aseguradora = {
    nombre: '',
    costo: 0,
    es_activo: true,
  }

  ben_data = {
    name: '',
    email: '',
    phone: '', 
    address: '',
    document: '',
    country: '',
    city: ''
  }

  new_commodity = {
    name: '',
    group: 0,
    grupo: 0,
    service: 0
  }

  new_coverage = {
    cobertura: '',
    tarifa: 0,
    mercancia: ''
  }

  com_data = {
    service : '',
    group: ''
  }

  selection = 1;
  phone; 

  clients = {
    list: true,
    add: false,
    admin: false,
    agencias: false,
    aseguradoras: false
  }

  users = {
    add: true,
    list: false
  }

  all_contractors;
  selected_client;
  aseg_selected;
  pol_ind_selected;
  all_admins;
  all_agencias;
  all_agencias_filter;
  agencias_completas: any;
  all_aseguradora;
  all_aseguradora_filter;

  sel_client_options = {
    edit: false,
    commodities: false,
    insurances: false
  };

  commodity_selected = {
    paquete_mercancia: [],
    url: ''
  };

  all_asegurados;
  pol_ind;

  show_button_policy = false;
  file;
  pages_users;
  config;
  flag_cliente = 0;
  rate_exchange_mxn = 0;
	rate_exchange_usd = 0;
  rate_exchange_eur = 0;
	rate_exchange = [];
  showModal = false;
  modalTypeReport = "";
  showModalDelete = false;
  showTextDisableAgencia = false
  showTextDisableAseguradora = false
  selected_user = null;
  startDate = null;
  endDate=null;
  

  // @Output() parLogin   : EventEmitter<string> = new EventEmitter<string>();
  @Output() clientData        = new EventEmitter();
  @Output() editPolicyInd     = new EventEmitter();
  @Output() reqClients        = new EventEmitter();
  @Output() reqUsers          = new EventEmitter();
  @Output() reqUsersA         = new EventEmitter();
  @Output() paramsCoverages   = new EventEmitter();
  @Output() contractorsFilter = new EventEmitter();
  @Output() contractorsFilterUser = new EventEmitter();
  @Output() patchContractor   = new EventEmitter();
  @Output() benData           = new EventEmitter();
  @Output() getCountries      = new EventEmitter();
  @Output() getServices       = new EventEmitter();
  @Output() newCommodity      = new EventEmitter();
  @Output() newCoverage       = new EventEmitter();
  @Output() resUsersByGroup   = new EventEmitter();
  @Output() patchUsers        = new EventEmitter();
  @Output() deleteRegister    = new EventEmitter();
  @Output() getContractors    = new EventEmitter();
  @Output() reqInsurancesClient = new EventEmitter();
  @Output() patchInsurances   = new EventEmitter();
  @Output() getAsegurados     = new EventEmitter();
  @Output() userAdmins        = new EventEmitter();
  @Output() listAgencias      = new EventEmitter();
  @Output() reqAgencias       = new EventEmitter();
  @Output() listAseguradora   = new EventEmitter();
  @Output() reqAseguradora    = new EventEmitter();
  @Output() reqComplemento    = new EventEmitter();
  @Output() getRateExchange = new EventEmitter();
  // @Output() getReportClient = new EventEmitter();
  @Output() getReportAccountStatements  = new EventEmitter();
  @Output() getReportClientCommissions  = new EventEmitter();
  @Output() getReportAdviserCommissions = new EventEmitter();


  @Input()
  set groupList(data: any) {
     this.clients_ = data;
  }  

  country_list = [];
  @Input() 
    set countryList(data: any) {
      if(data) {
        this.country_list = data;
      }
    }

  @Input()
    set clientResult(data: any) {
      if(data && this.flag_cliente > 0) {
        // console.log("clientResult data1 ", data)
        this.sel_client_options.edit = true;
        this.sel_client_options.commodities = false;
        this.sel_client_options.insurances  = false;
        this.clients.add = false;
        this.clients.list = true
        this.selected_client = data;
        this.selection = 1;
        this.actual_client(this.selected_client);
        this.client_options_edit(1, this.selected_client);
        this.flag_cliente++;
        // this.new_client_ = data;
        // localStorage.new_client = JSON.stringify(data);
      }
    }

  @Input()
    set contractorsDatasource(data: any) {
      if(data) {
        this.all_contractors = data;
        
        // agregar complemento_group si es cliente al localStorage
        if (localStorage.client_group) {
          let client_group = JSON.parse(localStorage.client_group);

          for (let key in this.all_contractors) {
            for (let key_group in this.all_contractors[key].complemento_group) {
              client_group.complemento_group = this.all_contractors[key].complemento_group[key_group];
            }
          }
          localStorage.setItem("client_group", JSON.stringify(client_group));
        }
        this.go_contractors_list('insurances');
      }
    }

  @Input()
    set usersAdmins(data: any) {
      console.log("usersAdmins ", data);
      if(data) {
        this.all_admins = data;
      }
    }

  @Input()
    set listsAgencias(data: any) {
      if(data) {
        // cargar su agencia si es cliente
        if (localStorage.admin_full == 'false' && !localStorage.admin) {
          if(JSON.parse(localStorage.client_group).complemento_group) {
            this.all_agencias = [JSON.parse(localStorage.client_group).complemento_group.agencia];
            this.all_agencias_filter = [JSON.parse(localStorage.client_group).complemento_group.agencia].filter((item) => item.es_activo === true);
          } else {
            this.all_agencias = [];
            this.all_agencias_filter = [];
          }
        } else {
          this.all_agencias = data;
          this.all_agencias_filter = data.filter((item) => item.es_activo === true)
        }
        // console.log("this.all_agencias_filter", this.all_agencias_filter)
      }
    }

  // Input para obtener todas las agencias completas
  @Input()
    set allAgencias(data: any) {
      if(data) {
        this.agencias_completas = data.filter((item: any) => item.es_activo === true);
      }
    }

  @Input()
    set listsAseguradora(data: any) {
      console.log("listsAseguradora", data)
      if(data) {
        this.all_aseguradora = data;
        this.all_aseguradora_filter = data.filter((item) => item.es_activo === true)
        console.log("this.all_aseguradora_filter", this.all_aseguradora_filter)
      }
    }

  @Input()
    set resAsegurados(data: any) {
      if(data){
        this.all_asegurados = data;
      }
    }

  @Input()
    set returnTo(data: string) {
      if(data == 'contractor_list') {
        this.selected_client = null;
        this.clients.list    = true;
        this.clients.add     = false;
      }else if(data == 'clear_user') {
        console.log('Clear user')
        this.data= {
          name: '',
          email: '',
          telefono: null, 
          direccion: '',
          rfc: '',
          pais: '',
          ciudad: '',
          file: null,
          file_: {}
        }
        this.phone = null;
      }
    }

  @Input()
    set servicesData(data: any) {
      if(data) {
        this.services_data_ = data;
      }
    }
  @Input() 
    set commodityAdded(data: any) {
      if(data) {
        if(!this.selected_client.mercancias) {
          this.selected_client.mercancias = [];
        }


        this.selected_client.mercancias.push(data);
        this.commodity_selected = data;
      }
    }

  @Input()
    set coverageAdded(data: any) {
      if(data) {
        this.commodity_selected.paquete_mercancia.push(data);
      }
    }

  @Input() 
    set usersDatasource(data:any) {
      if(data) {
        this.users_datasource_ = data.results;
        this.pages_users = data;
      }
    }

  @Input() 
    set newUser(data: any) {
      if(data) {
        this.datasource = { 
          first_name: '',
          last_name: '', 
          email: '', 
          password: '',
          username:'', 
          grupo: '',
          admin2: false
        };
        // this.selectUserOption(1);
        this.select_client(this.selected_client);
      }
    }

  @Input()
    set changesUser(data: any) {
      if(data) {
      // console.log('aaa', data);
        this.user_sel_ = null;
        this.selectUserOption(1);
      }
    }
  // original_data;

  @Input() 
    set resultInsurances(data: any) {
      
      if(data) {
        if(data.results) {
          localStorage.original_insurances = JSON.stringify(data.results);
          this.insurances_client_ = data.results;
        }
        
      }
    }

  @Input()
    set ratesChanged(data: boolean) {
      if(data) {
        this.edit = false;
      }
    }

  @Input()
	set resultExchange(data: any) {

		if (data) {
			this.rate_exchange = data;
			this.rate_exchange_mxn = 1;
			this.rate_exchange_usd = parseFloat(data.dolar);
			this.rate_exchange_eur = parseFloat(data.euro);
		}
	}


  edit;
  // _pag_config = [];
  totalPages;
  _pag_config = { count: 0, next: '', previous: ''};
  // _pag_config = [];

  // Variables paginacion
  pages;
  count;
  next;
  previous;
  pages_;

  @Input()
    set pagConfig(data: any) {
      this._pag_config = {count: 0, next: '', previous: ''};
      this.totalPages = [];
      
      this._pag_config = data;

      if(this._pag_config) {

          // ! paginador para agencias
          if (this._pag_config.next && this._pag_config.next.indexOf('agencia') !== -1 && localStorage.client_group) {
            this._pag_config = {count: 0, next: '', previous: ''};
            this.totalPages = [];
          } else {
            if(this._pag_config.count > 0) {
    
              this.pages_ = Math.ceil(this._pag_config.count / 10);
    
              for (var i = 0; i < this.pages_; i++) {
                  this.totalPages.push(i+1);
              }
          }
        }
      // console.log('pagination', data);
      }
    }

  	@Input() 
		set resultReportClient(data: any) {
			if(data) {
			 
			}
		}

  // ViewChild para el modal de reportes
  @ViewChild('modalReportes') modal: ElementRef;
  @ViewChild('modalEliminar') modalEliminar: ElementRef;

  registroEliminar: any;

  ngOnInit() {
    
    if(localStorage.new_client) {
      this.new_client_ = JSON.parse(localStorage.new_client);
    }

    // session storage
    if(sessionStorage.user_info) {
      this.user_info = JSON.parse(sessionStorage.user_info);
    }
    if(sessionStorage.config) {
      this.config = JSON.parse(sessionStorage.config);
    }
    if(localStorage['admin_full']=='true') {
      this.is_full_admin = true;
    } else {
      this.is_full_admin = false;
    }
    if(localStorage['admin']=='true') {
      this.admin = true;
    } else {
      this.admin = false;
    }
    this.selectClientOption(1);

    this.getCountries.emit('ok');
    this.getRateExchange.emit('ok');
    //this.listAgencias.emit();
    
  }

  constructor() {

  }

  for_all;

  applyAll(param) {

    if(param == 'add') {
      for(let i in this.new_client_.mercancias) {
        let mercancias = this.new_client_.mercancias[i];

        for(let j in mercancias.paquete_mercancia) {
          let item = mercancias.paquete_mercancia[j];
          item.tarifa = this.for_all;
        }

      }
    } else {

      for(let i in this.selected_client.mercancias) {
        let mercancias = this.selected_client.mercancias[i];

        for(let j in mercancias.paquete_mercancia) {
          let item = mercancias.paquete_mercancia[j];
          item.tarifa = this.for_all;
        }

      }
      
    }

  }

  user_sel_;
  user_sel_admin;
  add_new;
  add_new_agencia;
  add_new_aseguradora;

  user_selected_(item) {
    this.user_sel_ = item;
    // console.log('item', item);
  }

  user_selected_admin(item) {
    this.add_new = true;
    
    this.datasource = item;

    this.datasource.admin2 = !item.is_superuser;
    // console.log('item', item);
  }
  saveChangesUser(param) {

    if(param.change_password) {

    } else {
      delete param.password;
      delete param.check_password;
    }
    // console.log('param', param);

    param.type = 'users';
    // console.log('param', param);
    this.patchUsers.emit(param);
  }

  actual_client(item) {
    if (item.complemento_group.length === 0){
        item.complemento_group = this.data_complemento_group
    }

    if (item.complemento_group[0].agencia === null || item.complemento_group[0].agencia === undefined ||
        item.complemento_group[0].agencia === "null" || item.complemento_group[0].agencia === "undefined" ){
        item.complemento_group[0].agencia = [{ nombre:'', url:'' }]
    }
    console.log("actual_client item ", item.complemento_group)
    this.selected_client = item;

    for(let i in this.selected_client.mercancias) {
      let item_ = this.selected_client.mercancias[i];
      for(let k in item_.paquete_mercancia) {
        let item_pack = item_.paquete_mercancia[k];
        
        if(item_pack.tarifa && (item_pack.tarifa).indexOf('%') > -1) {
          item_pack.tarifa = (item_pack.tarifa).replace(/%/g, '');
        }

        if(item_pack.tarifa) {
          item_pack.tarifa = item_pack.tarifa + '%';
        }

        if(item_pack.tasa_venta && (item_pack.tasa_venta).indexOf('%') > -1) {
          item_pack.tasa_venta = (item_pack.tasa_venta).replace(/%/g, '');
        }

        if(item_pack.tasa_venta) {
          item_pack.tasa_venta = item_pack.tasa_venta + '%';
        }

        if(item_pack.prima_adquisicion && (item_pack.prima_adquisicion).indexOf('%') > -1) {
          item_pack.prima_adquisicion = (item_pack.prima_adquisicion).replace(/%/g, '');
        }

        if(item_pack.prima_adquisicion) {
          item_pack.prima_adquisicion = item_pack.prima_adquisicion + '%';
        }
      }
    }

    this.cli_selected = null;
    this.client_options_edit(1, this.selected_client)

    if(item.individual_policy_cliente.length){
      if(item.individual_policy_cliente[0].limite_maximo != null && item.individual_policy_cliente[0].deducibles != null){
        this.show_button_policy = false;
      }
      else{
        this.show_button_policy = true;
      }
    }
    console.log("selected_client ", this.selected_client)
  }

  client_options_edit(option, item) {
    this.aseg_selected = false;
    this.pol_ind_selected = false;
    switch(option) {
      // edicion
      case 1:
        this.selected_client = item;
        this.cli_selected = null;
        
        this.sel_client_options.edit        = true;
        this.sel_client_options.commodities = false;
        this.sel_client_options.insurances  = false;
        this.reqInsurancesClient.emit(item);

        break;

      // add tarifas y paquetes
      case 2:
        this.selected_client = item;
        this.new_commodity.grupo = item.contratantes_info[0].grupo;
        
        this.sel_client_options.commodities = true;
        this.sel_client_options.edit        = false;
        this.sel_client_options.insurances  = false;

        break;
      case 3:
        this.selected_client = item;
        // this.new_commodity.grupo = item.contratantes_info[0].grupo;
        
        this.sel_client_options.commodities = false;
        this.sel_client_options.edit        = false;
        this.sel_client_options.insurances  = true;

        this.reqInsurancesClient.emit(item);

        break;

      default:
        break;
    }
  };

  clear_control(param, mer_index, pack_index) {
    if(!param) {
      this.for_all = '0.'; 
    } else { 
      let mercancia = this.selected_client.mercancias[mer_index];
      // console.log("mercancia", mercancia)
      // let cobertura = mercancia.paquete_mercancia[pack_index];
      let cob;
      let cobertura;
      if(pack_index == 0){
        cob = 'TOTAL LOSS';
      }else if (pack_index == 1){
        cob = 'FULL COVER';
      }else if(pack_index == 2){
        cob = 'FULL COVER PLUS';
      }
      for(var i = 0; i < mercancia.paquete_mercancia.length; i++){
        if(cob == mercancia.paquete_mercancia[i].cobertura){
          cobertura = mercancia.paquete_mercancia[i];
        }
      }
      cobertura.tarifa = '0.';
    }
  }

  clear_control_tasa_tarifa(type, param, mer_index, pack_index) {
    if(!param) {
      this.for_all = '0.';
    } else {
      // console.log("clear_control_tasa_tarifa", param, mer_index, pack_index)
      let mercancia = this.selected_client.mercancias[mer_index];
      let cobertura = mercancia.paquete_mercancia[pack_index];
      if(type =='tarifa'){
        cobertura.tarifa = '0.';
      }else if(type =='tasa_venta'){
        cobertura.tasa_venta = '0.';
      }
    }

  }

  addPercentTasaVenta(param, mer_index, pack_index) {
    var _mercancia = this.selected_client.mercancias[mer_index];
     // console.log("addPercentTasaVenta", param, mer_index, pack_index)

    if(!param) {

      if(parseFloat(this.for_all) == 0) {
        this.for_all = '0.00'
      }

      if(String(this.for_all).indexOf('%') > -1) {
        this.for_all = (this.for_all).replace(/%/g, '');
      }

      this.for_all = this.for_all + '%';

    } else {

      let mercancia = this.selected_client.mercancias[mer_index];
      // let cobertura = mercancia.paquete_mercancia[pack_index];
      let cob;
      let cobertura;
      if(pack_index == 0){
        cob = 'TOTAL LOSS';
      }else if (pack_index == 1){
        cob = 'FULL COVER';
      }else if(pack_index == 2){
        cob = 'FULL COVER PLUS';
      }
      for(var i = 0; i < mercancia.paquete_mercancia.length; i++){
        if(cob == mercancia.paquete_mercancia[i].cobertura){
          cobertura = mercancia.paquete_mercancia[i];
        }
      }

      if (cobertura === undefined || cobertura === "undefined" ){
        cobertura = mercancia.paquete_mercancia[pack_index];
      }

      if(parseFloat(cobertura.tasa_venta) == 0) {
        cobertura.tasa_venta = '0.00'
      }
      cobertura.tasa_venta = (cobertura.tasa_venta).replace(/%/g, '');
      cobertura.tasa_venta = cobertura.tasa_venta + '%';
    }
  };

  addPercent(param, mer_index, pack_index) {
     var _mercancia = this.selected_client.mercancias[mer_index];
     // console.log("addPercent", param, mer_index, pack_index)
     // var_cobertura = _mercancia.paquete_mercancia[pack_index];

     // aquí trae la aseguradora
     // console.log(this.selected_client.mercancias[mer_index]);


    if(!param) {

      if(parseFloat(this.for_all) == 0) {
        this.for_all = '0.00'
      }
      
      if(String(this.for_all).indexOf('%') > -1) {
        this.for_all = (this.for_all).replace(/%/g, '');
      }

      this.for_all = this.for_all + '%'; 

    } else {

      let mercancia = this.selected_client.mercancias[mer_index];
      // let cobertura = mercancia.paquete_mercancia[pack_index];
      let cob;
      let cobertura;
      if(pack_index == 0){
        cob = 'TOTAL LOSS';
      }else if (pack_index == 1){
        cob = 'FULL COVER';
      }else if(pack_index == 2){
        cob = 'FULL COVER PLUS';
      }
      for(var i = 0; i < mercancia.paquete_mercancia.length; i++){
        if(cob == mercancia.paquete_mercancia[i].cobertura){
          cobertura = mercancia.paquete_mercancia[i];
        }
      }

      if (cobertura === undefined || cobertura === "undefined" ){
        cobertura = mercancia.paquete_mercancia[pack_index];
      }

      if(parseFloat(cobertura.tarifa) == 0) {
        cobertura.tarifa = '0.00'
      }

      // if(String(cobertura.tarifa).indexOf('%') > -1) {
        cobertura.tarifa = (cobertura.tarifa).replace(/%/g, '');
      // }

      cobertura.message = '';

      if(mercancia.service_name == 'GNP MXN' || mercancia.service_name == 'GNP USD' || mercancia.service_name == 'CHUBB USD') {
        if(parseFloat(cobertura.tarifa) < 0.14) {
          cobertura.tarifa = '0.14';
            cobertura.message = 'La tarifa minima para GNP es de 0.14%';
        }
      } else if(mercancia.service_name == 'Banorte') {
        if(parseFloat(cobertura.tarifa) < 0.20) {
          cobertura.tarifa = '0.20';
          cobertura.message = 'La tarifa minima para Banorte es de 0.20%'; 
        }
      } else {
        // JAH
        if(mercancia.name == 'Rompibles') {
          switch (cobertura.cobertura) {
            case "TOTAL LOSS":
              
              if(parseFloat(cobertura.tarifa) < 0.20) {
                cobertura.tarifa = '0.20';
                cobertura.message = 'La tarifa minima para Rompibles en JAH es de 0.20%'; 
              }

              break;

            default:
              // code...
              break;
          }
        } else if(mercancia.name == 'Químicos') {
          switch (cobertura.cobertura) {
            case "FULL COVER PLUS":
              
              if(parseFloat(cobertura.tarifa) < 0.22) {
                cobertura.tarifa = '0.22';
                cobertura.message = 'La tarifa minima para Químicos en JAH es de 0.22%'; 
              }

              break;
            
            case "FULL COVER":
              if(parseFloat(cobertura.tarifa) < 0.22) {
                cobertura.tarifa = '0.22';
                cobertura.message = 'La tarifa minima para Químicos en JAH es de 0.22%'; 
              }
            break;

            case "TOTAL LOSS":
              if(parseFloat(cobertura.tarifa) < 0.20) {
                cobertura.tarifa = '0.20';
                cobertura.message = 'La tarifa minima para Químicos en JAH es de 0.22%'; 
              }
            break;


            default:
              // code...
              break;
          }
        } else if(mercancia.name == 'Refrigerados') {
          switch (cobertura.cobertura) {
            case "FULL COVER PLUS":
              
              if(parseFloat(cobertura.tarifa) < 0.40) {
                cobertura.tarifa = '0.40';
                cobertura.message = 'La tarifa minima para Refrigerados en JAH es de 0.40%'; 
              }

              break;
            
            case "FULL COVER":
              if(parseFloat(cobertura.tarifa) < 0.40) {
                cobertura.tarifa = '0.40';
                cobertura.message = 'La tarifa minima para Refrigerados en JAH es de 0.40%'; 
              }
            break;

            case "TOTAL LOSS":
              if(parseFloat(cobertura.tarifa) < 0.20) {
                cobertura.tarifa = '0.20';
                cobertura.message = 'La tarifa minima para Refrigerados en JAH es de 0.20%'; 
              }
            break;


            default:
              // code...
              break;
          }
        } else if(mercancia.name == 'Vehículos') {
          switch (cobertura.cobertura) {
            case "FULL COVER PLUS":
              
              if(parseFloat(cobertura.tarifa) < 0.22) {
                cobertura.tarifa = '0.22';
                cobertura.message = 'La tarifa minima para Vehículos en JAH es de 0.22%'; 
              }

              break;
            
            case "FULL COVER":
              if(parseFloat(cobertura.tarifa) < 0.22) {
                cobertura.tarifa = '0.22';
                cobertura.message = 'La tarifa minima para Vehículos en JAH es de 0.22%'; 
              }
            break;

            case "TOTAL LOSS":
              if(parseFloat(cobertura.tarifa) < 0.20) {
                cobertura.tarifa = '0.20';
                cobertura.message = 'La tarifa minima para Vehículos en JAH es de 0.20%'; 
              }
            break;


            default:
              // code...
              break;
          }
        } else if(mercancia.name == 'Electrónicos') {
          switch (cobertura.cobertura) {
            case "FULL COVER PLUS":
              
              if(parseFloat(cobertura.tarifa) < 0.40) {
                cobertura.tarifa = '0.40';
                cobertura.message = 'La tarifa minima para Electrónicos en JAH es de 0.40%'; 
              }

              break;
            
            case "FULL COVER":
              if(parseFloat(cobertura.tarifa) < 0.40) {
                cobertura.tarifa = '0.40';
                cobertura.message = 'La tarifa minima para Electrónicos en JAH es de 0.40%'; 
              }
            break;

            case "TOTAL LOSS":
              if(parseFloat(cobertura.tarifa) < 0.26) {
                cobertura.tarifa = '0.26';
                cobertura.message = 'La tarifa minima para Electrónicos en JAH es de 0.26%'; 
              }
            break;


            default:
              // code...
              break;
          }
        } else if(mercancia.name == 'Mercancía General' || mercancia.name == 'Mercancía general') {
          switch (cobertura.cobertura) {
            case "FULL COVER PLUS":
              
              if(parseFloat(cobertura.tarifa) < 0.20) {
                cobertura.tarifa = '0.20';
                cobertura.message = 'La tarifa minima para Mercancía General en JAH es de 0.20%'; 
              }

              break;
            
            case "FULL COVER":
              if(parseFloat(cobertura.tarifa) < 0.20) {
                cobertura.tarifa = '0.20';
                cobertura.message = 'La tarifa minima para Mercancía General en JAH es de 0.20%'; 
              }
            break;

            case "TOTAL LOSS":
              if(parseFloat(cobertura.tarifa) < 0.19) {
                cobertura.tarifa = '0.19';
                cobertura.message = 'La tarifa minima para Mercancía General en JAH es de 0.19%'; 
              }
            break;


            default:
              // code...
              break;
          }
        }




      }

      cobertura.tarifa = cobertura.tarifa + '%';
    }

  }

  addPrimaMinima(param, mer_index, pack_index) {


   if(param)  {

     let mercancia = this.selected_client.mercancias[mer_index];
     // let cobertura = mercancia.paquete_mercancia[pack_index];
     let cob;
     let cobertura;
     if(pack_index == 0){
       cob = 'TOTAL LOSS';
     }else if (pack_index == 1){
       cob = 'FULL COVER';
     }else if(pack_index == 2){
       cob = 'FULL COVER PLUS';
     }
     for(var i = 0; i < mercancia.paquete_mercancia.length; i++){
       if(cob == mercancia.paquete_mercancia[i].cobertura){
         cobertura = mercancia.paquete_mercancia[i];
       }
     }



     cobertura.message = '';

     if(mercancia.service_name == 'GNP MXN' || mercancia.service_name == 'GNP USD' || mercancia.service_name == 'CHUBB USD') {
        // do nothing 
     }else {
       // JAH

             
             if(parseFloat(cobertura.prima_minima) < 35 && cobertura.moneda=='USD') {
               cobertura.prima_minima = '35';
             }else if(parseFloat(cobertura.prima_minima) < (35* this.rate_exchange_usd) && cobertura.moneda=='MXN') {
              cobertura.prima_minima = (35* this.rate_exchange_usd);
            } else if(parseFloat(cobertura.prima_minima) < ((35* this.rate_exchange_usd)/this.rate_exchange_eur) && cobertura.moneda=='EUR') {
              cobertura.prima_minima = ((35* this.rate_exchange_usd)/this.rate_exchange_eur);
            }

        }
     }

 }




  insurancesSelected = [];

  changeInsurance(item) {
    // let original_data = JSON.parse(localStorage.original_insurances);
    // for(let i in original_data) {
    //   let original_ = original_data[i];
    //   if(original_.id == item.id) {
    //     if(original_.is_active == item.is_active) {

    //       for(let j in this.insurancesSelected) {
    //         if(original_.id == this.insurancesSelected[j].id) {
    //           this.insurancesSelected.splice(parseInt(j), 1);
    //         }
    //       }

    //     } else {
    //       this.insurancesSelected.push(item);
    //     }
    //   }
    // }
    let original_data = this.insurances_client_
    let arrayO = [];
    for(var i = 0; i < original_data.length; i++){
      if(item.id == original_data[i].id){
        arrayO.push(item);
      } else{
        arrayO.push(original_data[i]); 
      }
    }
    this.insurancesSelected = arrayO;
  }

  patchInsurances_() {

    if(this.insurancesSelected.length) {
      // this.patchInsurances.emit(this.insurancesSelected);
      this.patchInsurances.emit(this.insurances_client_);
    }
    
  }

  /*
  delete_client(paritem) {
    paritem.url = paritem.contratantes_info[0].grupo;
    paritem.type = 'client';
    
    this.deleteRegister.emit(paritem);
  }
  */

  delete_client() {
    this.registroEliminar.url = this.registroEliminar.contratantes_info[0].grupo;
    this.registroEliminar.type = 'client';

    this.deleteRegister.emit(this.registroEliminar);
  }

  search_client(client_name) {
    let param ;
    if (client_name){
        param =  {'cadena':client_name};
    }else{
      param = '';
    }
    this.contractorsFilter.emit(param);
  }

  go_contractors_list(param) {
    this.selected_client = null; 
    this.cli_selected = null;
    this.for_all = '';
    this.aseg_selected = false;
    this.pol_ind_selected = false;

    this.commodity_selected = {
      paquete_mercancia: [],
      url: ''
    };
    this.sel_client_options[param] = false;
    this.new_commodity = {
      name: '',
      grupo: 0,
      group: 0,
      service: 0
    }
  }

  selectClientOption(param) {
    // Restableciendo valores del paginador
    this.actual_page = 1;
    this.selectedIndex = 0;
    this.start = 0;
    this.end = 5;

    this.all_contractors = [];
    if(param == 0) {
      this.clients = {
        add: true,
        list: false,
        admin: false,
        agencias: false,
        aseguradoras: false
      }
      this.data= {
        name: '',
        email: '',
        telefono: null, 
        direccion: '',
        rfc: '',
        pais: '',
        ciudad: '',
        file: null,
        file_: {}
      }
    } else if(param == 2) {
      this.clients = {
        add: false,
        list: false,
        admin: true,
        agencias: false,
        aseguradoras: false
      }

      if (localStorage.admin_full == 'false' && !localStorage.admin) {
        let usuario = JSON.parse(sessionStorage.user_info);
        // TODO: obtener el usuario del cliente
        let usuarioCliente = {
          first_name: usuario.first_name,
          last_name: usuario.last_name,
          email: usuario.email,
          username: usuario.email
        }
  
        this.all_admins = [usuarioCliente];
      } else {
        this.userAdmins.emit();
      }
    } else if(param == 3) {
      this.clients = {
        add: false,
        list: false,
        admin: false,
        agencias: true,
        aseguradoras: false
      }

      this.listAgencias.emit();
    } else if(param == 4) {
      this.clients = {
        add: false,
        list: false,
        admin: false,
        agencias: false,
        aseguradoras: true
      }
      this.listAseguradora.emit();
    } else {
      console.log('select client option -> param:', param);
      this.clients = {
        add: false,
        list: true,
        admin: false,
        agencias: false,
        aseguradoras: false
      }

      this.cli_selected = null;
      this.new_client_ = null;

      let isAdmin = localStorage.getItem('admin_full');
      let grupoCliente = localStorage.getItem('client_group');
      let nombreClienteActual: string;
      let abreviaturasTipos = ['sa de cv', 's.a. de c.v.', 'sa de', 's.a. de', 'spr de rl', 's de rl', 's de rl de cv', 'sc', 'scl', 'scs', 'sapi', 'llc', 'inc', 'srl de cv'];

      if (grupoCliente && isAdmin) {
        if (isAdmin === 'false') {
          grupoCliente = JSON.parse(grupoCliente);
          nombreClienteActual = grupoCliente['contratantes_info'][0].nombre.trim().toLowerCase();
          for (let i = 0; i < abreviaturasTipos.length; ++i) {
            if (nombreClienteActual.indexOf(abreviaturasTipos[i]) !== -1) {
              nombreClienteActual = nombreClienteActual.substring(0, nombreClienteActual.indexOf(abreviaturasTipos[i]));
              break;
            }
          }
          this.contractorsFilter.emit(nombreClienteActual);
        }
      } else {
        // get Contractors list
        this.contractorsFilter.emit('');
      }

    }
  };

  delete_user(param) {
    param.client = this.cli_selected.id;
    param.type = 'users';
    // console.log('param', param);
    this.deleteRegister.emit(param);
    
  }

  /*
  delete_admin(param) {
    param.type = 'admin';
    // console.log('param', param);
    this.deleteRegister.emit(param);
    
  }
  */
  
  // Validar eliminar admin
  delete_admin() {
    this.registroEliminar.type = 'admin';
    this.deleteRegister.emit(this.registroEliminar);
  }

  selectUserOption(param) {

    if(param == 0) {
      this.users = {
        add: true,
        list: false
      }
    } else {
      this.users = {
        add: false,
        list: true
      }

      // get Contractors list
      // this.contractorsFilter.emit('');
    }

  }

  client;
  cli_selected = { id: null };

  stringClient(param) {
    // param = '0000000';
    this.cli_selected = { id: null };
    this.user_sel_ = null;    
    this.contractorsFilter.emit(param);

    
  }

  select_aseg(quote, param) {
    this.aseg_selected = true;
    this.pol_ind_selected = false;
    this.cli_selected = param;
    this.sel_client_options = {
      edit: false,
      commodities: false,
      insurances: false
    };

    this.getAsegurados.emit(quote.id);

  };

  selec_pol_ind(quote, param) {
    this.pol_ind_selected = true;
    this.aseg_selected = false;
    this.cli_selected = param;
    this.sel_client_options = {
      edit: false,
      commodities: false,
      insurances: false
    };

    this.getAsegurados.emit(quote.id);

  };

  select_client(param) {
    this.aseg_selected = false;
    this.pol_ind_selected = false;
    this.sel_client_options = {
      edit: false,
      commodities: false,
      insurances: false
    };
    // this.selection = 2;
    this.selectUserOption(1);
    this.cli_selected = param;
    // aquí
    this.resUsersByGroup.emit(param);
  }

  save_commodity() {
    
    this.newCommodity.emit(this.new_commodity);
  
  }

  save_coverage() {

    this.new_coverage.mercancia = this.commodity_selected.url;
    this.newCoverage.emit(this.new_coverage);
  }

  commodities() {
    this.getServices.emit('ok');
  }

  // benficiaryOption(param) {
  //    if(param == 0) {
  //     this.beneficiary = {
  //       add: true,
  //       list: false
  //     }
  //   } else {
  //     this.beneficiary = {
  //       add: false,
  //       list: true
  //     }

  //     // get Contractors list
  //     this.contractorsFilter.emit('');
  //   }
  // }

  savePolicyInd(params,event){
    if (this.file_selected){
      params.file_ = this.file_selected;
    }
    this.editPolicyInd.emit(params);
  }

  saveClient() {
    this.clientData.emit(this.data);
  }

  onFileChange(event) {      
    const formData: FormData = new FormData();
    formData.append('file', event.target.files[0], event.target.files[0].name);
    this.file_selected = formData;
    this.data.file_ = formData
  }
  onFileChangePolicy(event) {
    const formData: FormData = new FormData();
    formData.append('file', event.target.files[0], event.target.files[0].name);
    this.data.file_ = formData
  }

  saveBeneficiary() {
    this.benData.emit(this.ben_data);
  }

  patchInfoContractor(param) {
    this.patchContractor.emit(param.contratantes_info[0]);
  }

  checked_tarifa_tasa(cbox, item){
    if (cbox === "cbox2"){
        item.is_active_tasa_venta = false
    }
    if (cbox === "cbox4"){
        item.is_active_tarifa = false
    }
  }

  save(client){
    this.saveComplemento(client);
    this.patchInfoContractor(client);
    this.patchInsurances_();
    this.saveRates(client);
    this.go_contractors_list('edit');
    this.selectClientOption(1);
  };

  saveRates(param) {
    this.paramsCoverages.emit(param.mercancias);
  }
  saveComplemento(param) {
    param.complemento_group[0].grupo = param.contratantes_info[0].grupo
    param.complemento_group[0].agencia = param.complemento_group[0].agencia.url
    this.reqComplemento.emit(param.complemento_group[0]);
  };

  addUser() {
    this.selection = 2;  
    this.users = {
      list : true,
      add: false
    }
    this.reqClients.emit(2);
  }

  showAddAdminUser(){
    this.add_new = true;
    this.datasource = { 
      first_name: '',
      last_name: '', 
      email: '', 
      password: '', 
      grupo: '',
      username: '',
      admin2: false
    };
  }

  saveUser() {
    this.datasource.grupo = this.selected_client.id;
    this.reqUsers.emit(this.datasource);
  }

  saveUserA() {
    if(!this.datasource.admin2){
      this.datasource.admin2 = false;
    }
    if (this.datasource.username.length>30){
      alert('El usuario debe contener menos de 30 caracteres');
      return;
    }
    this.add_new = false
    this.reqUsersA.emit(this.datasource);
    this.selectClientOption(2);
  }

  changePass(param) {
    if(param) {

    } else {
      this.user_sel_.check_password ="";
      this.user_sel_.password ="";
    }
  }


  // FORMATOS

  validateValue(param, mer_index, pack_index) {
    if(!param) {

      if(parseFloat(this.for_all) >= 1) {
        this.for_all = '0.99';
        
        alert('El valor no puede ser mayor a 0.99%');
      } 
      // else {
        // this.checkStrigPercent(this.for_all);
      // }
    } 
    else { 
      let mercancia = this.selected_client.mercancias[mer_index];
      let cobertura = mercancia.paquete_mercancia[pack_index];

      if(parseFloat(cobertura.tarifa) >= 1) {
        cobertura.tarifa = '0.99';
        alert('El valor no puede ser mayor a 0.99%');
      }
      if(parseFloat(cobertura.tasa_venta) >= 1) {
        cobertura.tasa_venta = '0.99';
        alert('El valor no puede ser mayor a 0.99%');
      }
      // cobertura.tarifa = '0.';
    }
    
  }

  checkStrigPercent(param) {
    console.log('checkStrigPercent', param);
    let points = param.substring('.');
    // console.log(',points', points);     

  };

  checkValue(event, param) {

    if((event.code).search('Digit') > -1 || 
      (event.code).search('Numpad') > -1  ||
      event.code == 'Backspace' || 
      event.code == 'Delete' ||
      event.code == 'ArrowLeft' ||
      event.code == 'Tab' ||
      event.code == 'Enter' ||
      event.code == 'Period' ||
      event.code == 'NumpadDecimal' || 
      event.code == 'ArrowRight') { 

      return true;
    } else {
      return false;
    }
  };
  
  onInputChange(event, backspace) {
      // remove all mask characters (keep only numeric)
      var newVal = event.replace(/\D/g, '');
      var rawValue = newVal;

      if(backspace) {
        newVal = newVal.substring(0, newVal.length - 1);
      } 

      // don't show braces for empty value
      if(newVal.length == 0) {
        newVal = '';
      } 
      // don't show braces for empty groups at the end
      else if(newVal.length <= 3) {
        newVal = newVal.replace(/^(\d{0,3})/, '($1)');
      } else if(newVal.length <= 3) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
      } else {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
      }

      this.phone = newVal;
      this.data.telefono = rawValue;
      this.ben_data.phone;

  };

  // Paginador listado de clientes

  start = 0;
  actual_page = 1;
  end = 5;
  not_next;
  show_prev_block = false;

  not_prev;

  selectedIndex: number = null;

  setIndex(index: number) {
		this.selectedIndex = index;
	}

	removeClass() {
		this.selectedIndex = null;
	}

  previousBlockPages(params) {
    if(params) {
      if(this.start < this.actual_page) {
        this.start = this.start - 1 ;
                this.end = this.end - 1;
      }
    } else {
          this.start = this.start - 5 ;
          this.end = this.end - 5;

          if(this.end < this.totalPages.length) {
              this.not_next = false;
          }
        }

        if(this.end <= 5) {
            this.start = 0;
            this.end = 5;
            this.show_prev_block = false;
        }
  };

  selectPage(parPage) {

    if(this._pag_config.next || this._pag_config.previous) {

          var url = '';

          if(this._pag_config.next) {

            // console.log('PAGE', this._pag_config.next);
            url = this._pag_config.next.substring(0, this._pag_config.next.indexOf("&page=") + 6);
            url += parPage.toString();
            
          } else {
              url = '';
              if(this._pag_config.previous.indexOf('&page=') !== -1) {
                url = this._pag_config.previous.substring(0, this._pag_config.previous.indexOf("&page=") + 6);
                url += parPage.toString();
              } else {
                url = this._pag_config.previous
              }
          }
        }

        // if(this.status_quote) {
        //   url += ('&status='+this.status_quote);
        // }

        // console.log('url', url);
        // emit
        // this.contractorsFilter.emit(String(url));

        // emit
        this.contractorsFilter.emit({url: String(url)});

        this.actual_page = parPage;
        if(this.actual_page > 1) {
          this.not_prev = false;
        }

        if(this.actual_page == this.totalPages.length -1) {
          this.not_next = true;
        }
  };

  nextBlockPages(params) {
    this.show_prev_block = true;

        if(params) {
          if(this.end > this.actual_page) {
            this.start = this.start + 1 ;
            this.end = this.end + 1;
          }
        } else {
          if(this.end < this.totalPages.length) {
            this.start = this.start + 5 ;
            this.end = this.end + 5;

            if(this.end == this.totalPages.length) {
                this.not_next = true;
            }
          } else {
            this.not_next = true;
          }
        }
  };

  // Seleccionar pagina del listado de usuarios
  selectPageAdmin(parPage) {
    let url = '';

    if(this._pag_config.next) {
      url = this._pag_config.next.substring(0, this._pag_config.next.indexOf('?page=') + 6) + parPage.toString();
    } else {
      if(this._pag_config.previous.indexOf('?page=') !== -1) {
        url = this._pag_config.previous.substring(0, this._pag_config.previous.indexOf('?page=') + 6) + parPage.toString();
      } else {
        url = this._pag_config.previous
      }
    }

    // emit
    this.userAdmins.emit(String(url));

    // Establecer la pagina actual a parPage
    this.actual_page = parPage;

    if(this.actual_page > 1) {
      this.not_prev = false;
    } else {
      this.not_prev = true;
    }

    if(this.actual_page == this.totalPages.length) {
      this.not_next = true;
    } else {
      this.not_next = false;
    }
  }

  previousBlockPagesUser() {
    this.start = this.start - 5 ;
    this.end = this.end - 5;

    if(this.end < this.totalPages.length) {
      this.not_next = false;
    }

    if(this.end <= 5) {
      this.start = 0;
      this.end = 5;
      this.show_prev_block = false;
    }
  };

  selectPageUser(parPage) {
    var url = '';
    if(this._pag_config.next) {
      url = this._pag_config.next.substring(0, this._pag_config.next.indexOf("&page=") + 6);
      url += parPage.toString();
    } else {
      url = '';
      if(this._pag_config.previous.indexOf('&page=') !== -1) {
        url = this._pag_config.previous.substring(0, this._pag_config.previous.indexOf("&page=") + 6);
        url += parPage.toString();

      } else {
        url = this._pag_config.previous
      }
    }
    url += '&urlname=' + this.config.urlname;
    this.contractorsFilterUser.emit({url: String(url)});
    

        this.actual_page = parPage;
        if(this.actual_page > 1) {
          this.not_prev = false;
        }

        if(this.actual_page == this.totalPages.length -1) {
          this.not_next = true;
        }
  };

  nextBlockPagesUser() {
    if(this.end < this.totalPages.length) {
      this.start = this.start + 5 ;
      this.end = this.end + 5;

      if(this.end == this.totalPages.length) {
          this.not_next = true;
      }
    } else {
      this.not_next = true;
    }
  };

  show_modal_account_statements(item){
    this.modalTypeReport = "account_statements";
    this.select_client = item
    this.show_modal();
    // this.showModal =true;
  };
  show_modal_client_commissions(item){
    this.modalTypeReport = "client_commissions";
    this.select_client = item
    this.show_modal();
    // this.showModal =true;
  };
  show_modal_adviser_commissions(item){
    this.modalTypeReport = "adviser_commissions";
    this.select_client = item
    this.show_modal();
    // this.showModal =true;
  };
  close_modal(item){
    this.showModal =false;
    this.modalTypeReport = "";
  };

  show_modal(){
    // Limpiar modal de reportes
    this.limpiarModal();

    // Mostrar modal con JQuery
    $(this.modal.nativeElement).modal('show');
  }

  // Mostrar modal de eliminar
  show_modal_delete(item: any) {
    this.registroEliminar = item;
    // Mostrar modal con JQuery
    $(this.modalEliminar.nativeElement).modal('show');
  }

  closing_modal(){
    // Establecer la variable del tipo de reporte a vacio
    this.modalTypeReport = "";

    // Cerrar modal con JQuery
    $(this.modal.nativeElement).modal('hide');
  }

  limpiarModal(){
    // Limpiar modal con JQuery
    $(this.modal.nativeElement).find('input').val('');
    this.startDate = '';
    this.endDate = '';
  }

  // Banderas para validar fechas
  dateInfoStart: boolean = false;
  dateInfoUntil: boolean = false;
  fechaInvalidaStart: boolean = false;
  fechaInvalidaUntil: boolean = false;

  // Método validateUntilDate() para validar que la fecha de inicio
  // no sea mayor a la fecha de fin del evento
  validateUntilDate(endDate: any) {
    this.dateInfoStart = false;
    this.dateInfoUntil = false;
    this.fechaInvalidaUntil = false;
    if(endDate != 'Invalid Date') {
      if(this.startDate !== '' && this.startDate !== null && this.endDate !== null) {
        if(this.startDate > endDate) {
          this.startDate = new Date(endDate);
          this.dateInfoStart = true;
        }
      }
    } else {
      this.fechaInvalidaUntil = true;
    }
  }

  // Método validateStartDate() para validar que la
  // fecha de inicio del evento no sea mayor a la fecha de fin
  validateStartDate(startDate: any) {
    this.dateInfoUntil = false;
    this.dateInfoStart = false;
    this.fechaInvalidaStart = false;
    if(startDate != 'Invalid Date') {
      if(this.endDate !== '' && this.endDate !== null && this.startDate !== null) {
        if(startDate > this.endDate) {
          this.endDate = new Date(startDate);
          this.dateInfoUntil = true;
        }
      }
    } else {
      this.fechaInvalidaStart = true;
    }
  }

/*
  create_report()
  {
    let params =   {
      "start_date": this.startDate,
      "end_date": this.endDate,
      "client_id": this.select_client['id']
    }
    this.getReportClient.emit(params);
    console.log(params);
  }
  */
  create_report_account_statements(){
    let params =   {
      "start_date": this.startDate,
      "end_date": this.endDate,
      "client_id": this.select_client['id']
    }
    this.getReportAccountStatements.emit(params);

    // Cerrar el modal después de generar el reporte
    this.closing_modal();
  };

  create_report_client_commissions(){
    let params =   {
      "start_date": this.startDate,
      "end_date": this.endDate,
      "client_id": this.select_client['id']
    }
    this.getReportClientCommissions.emit(params);

    // Cerrar el modal después de generar el reporte
    this.closing_modal();
  };

  create_report_adviser_commissions(){
    let params =   {
      "start_date": this.startDate,
      "end_date": this.endDate,
      "client_id": this.select_client['id']
    }
    this.getReportAdviserCommissions.emit(params);

    // Cerrar el modal después de generar el reporte
    this.closing_modal();
  };
  
  close_modal_delete(item){
    this.showModalDelete =false;
  };
  showAddAgencias(){
    this.add_new_agencia = true;
    this.datasource_agencias = {
      nombre: '',
      es_activo: true,
    };
  };
  saveAgencia() {
    this.add_new_agencia = false
    this.reqAgencias.emit(this.datasource_agencias);
    this.selectClientOption(3);
  };
  show_modal_delete_agencia(item) {
    this.showModalDelete = true;
    this.datasource_agencias = item;
    this.showTextDisableAgencia = item.es_activo
  };
  disable_agencia(item) {
    //console.log('1 this.datasource_agencias', this.datasource_agencias);
    if(this.datasource_agencias.es_activo){
      this.datasource_agencias.es_activo = false;
    }else{
      this.datasource_agencias.es_activo = true;
    }
    this.showModalDelete = false;
    //console.log('2 this.datasource_agencias', this.datasource_agencias);
    this.reqAgencias.emit(this.datasource_agencias);
  };
  edit_agencia(item) {
    // console.log('item', item)
    this.add_new_agencia = true;
    this.datasource_agencias = item;
  };

  previousBlockPagesAgencias(params) {
    console.log("previousBlockPagesAgencias params", params)
    if(params){
        if(this.start < this.actual_page) {
            this.start = this.start - 1 ;
            this.end = this.end - 1;
      }
    } else {
          this.start = this.start - 5 ;
          this.end = this.end - 5;

          if(this.end < this.totalPages.length) {
              this.not_next = false;
          }
        }

        if(this.end <= 5) {
            this.start = 0;
            this.end = 5;
            this.show_prev_block = false;
        }
  };

  // Selecciona pagina de la lista de agencias
  selectPageAgencias(parPage: number) {
    let url = '';

    if (this._pag_config.next) {
      url = this._pag_config.next.substring(0, this._pag_config.next.indexOf("?page=") + 6) + parPage.toString();
    } else {
      if (this._pag_config.previous.indexOf("?page=") !== -1) {
        url = this._pag_config.previous.substring(0, this._pag_config.previous.indexOf("?page=") + 6) + parPage.toString();
      } else {
        url = this._pag_config.previous;
      }
    }

    // emit
    this.listAgencias.emit(String(url));

    // Establecer pagina actual
    this.actual_page = parPage;

    if (this.actual_page > 1) {
      this.not_prev = false;
    } else {
      this.not_prev = true;
    }

    if (this.actual_page == this.totalPages.length) {
      this.not_next = true;
    } else {
      this.not_next = false;
    }
  }

  nextBlockPagesAgencias(params) {
    console.log("nextBlockPagesAgencias params", params)
    this.show_prev_block = true;

        if(params) {
          if(this.end > this.actual_page) {
            this.start = this.start + 1 ;
            this.end = this.end + 1;
          }
        } else {
          if(this.end < this.totalPages.length) {
            this.start = this.start + 5 ;
            this.end = this.end + 5;

            if(this.end == this.totalPages.length) {
                this.not_next = true;
            }
          } else {
            this.not_next = true;
          }
        }
  };
  //Aseguradora
  showAddAseguradora(){
    this.add_new_aseguradora = true;
    this.datasource_aseguradora = {
        nombre: '',
        costo: 0,
        es_activo: true,
      }
  };
  saveAseguradora() {
    this.add_new_aseguradora = false
    this.reqAseguradora.emit(this.datasource_aseguradora);
    this.selectClientOption(4);
  };
  show_modal_delete_aseguradora(item) {
    this.showModalDelete = true;
    this.datasource_aseguradora = item;
    this.showTextDisableAseguradora = item.es_activo
  };
  disable_aseguradora(item) {
    // console.log('1 this.datasource_aseguradora', this.datasource_aseguradora);
    if(this.datasource_aseguradora.es_activo){
      this.datasource_aseguradora.es_activo = false;
    }else{
      this.datasource_aseguradora.es_activo = true;
    }
    this.showModalDelete = false;
    // console.log('2 this.datasource_aseguradora', this.datasource_aseguradora);
    this.reqAseguradora.emit(this.datasource_aseguradora);
  };
  edit_aseguradora(item) {
    // console.log('item', item)
    this.add_new_aseguradora = true;
    this.datasource_aseguradora = item;
  };

  // Selecciona el bloque anterior de la lista de aseguradoras
  previousBlockPagesAseguradora(params: any) {
    if (params) {
      if (this.start < this.actual_page) {
        this.start = this.start - 1;
        this.end = this.end - 1;
      }
    } else {
      this.start = this.start - 5;
      this.end = this.end - 5;

      if (this.end < this.totalPages.length) {
        this.not_next = false;
      }
    }

    if (this.end <= 5) {
      this.start = 0;
      this.end = 5;
      this.show_prev_block = false;
    }
  }

  selectPageAseguradora(parPage: number) {
    let url = '';

    if (this._pag_config.next) {
      url = this._pag_config.next.substring(0, this._pag_config.next.indexOf("?page=") + 6) + parPage.toString();
    } else {
      if (this._pag_config.previous.indexOf("?page=") !== -1) {
        url = this._pag_config.previous.substring(0, this._pag_config.previous.indexOf("?page=") + 6) + parPage.toString();
      } else {
        url = this._pag_config.previous;
      }
    }

    // emit
    this.listAseguradora.emit(String(url));

    // Establecer pagina actual
    this.actual_page = parPage;

    if (this.actual_page > 1) {
      this.not_prev = false;
    } else {
      this.not_prev = true;
    }

    if (this.actual_page == this.totalPages.length) {
      this.not_next = true;
    } else {
      this.not_next = false;
    }
  }

  nextBlockPagesAseguradora(params) {
    // console.log("nextBlockPagesAseguradora params", params)
    this.show_prev_block = true;

        if(params) {
          if(this.end > this.actual_page) {
            this.start = this.start + 1 ;
            this.end = this.end + 1;
          }
        } else {
          if(this.end < this.totalPages.length) {
            this.start = this.start + 5 ;
            this.end = this.end + 5;

            if(this.end == this.totalPages.length) {
                this.not_next = true;
            }
          } else {
            this.not_next = true;
          }
        }
  };

};


// WEBPACK FOOTER //
// ../esscalo_funcionalidad/src/components/group/group.component.ts